import React from "react";
import { BrowserView, isDesktop, MobileView } from "react-device-detect";
import Typography from "antd/es/typography";

import { FetchModalID } from "src/ipm-shared/components/GlobalUI/actions";
import Button from "src/bepaid/components/Form/controls/Button";
import DesktopModalLayout from "src/bepaid/components/Modal/components/DesktopModalLayout";
import MainLayout from "src/bepaid/layouts/MainLayout";

import styles from "./AccountPendingReviewModal.module.scss";
import classNames from "classnames";

function AccountPendingReviewModal(props: any) {
  const onClose = () => {
    props.toggleModal(FetchModalID.ACCOUNT_PENDING_REVIEW_MODAL);
  };

  const isEmailSuggestion = props.showEmailSuggestionBanner;

  const renderDescription = () => {
    if (isEmailSuggestion) {
      return (
        <p className={styles.description}>
          Our team has reached out via email for more information. Please check
          your email for more details. If you need assistance, you may reach out
          to us at{" "}
          <Typography.Link href="mailto:support@ipaymy.com">
            <strong>support@ipaymy.com</strong>
          </Typography.Link>
          .
        </p>
      );
    }
    return (
      <>
        <p className={styles.description}>
          Your verification has been submitted successfully and is now under
          review.
        </p>
        <p className={styles.subHeading}>What happens next?</p>
        <ul className={styles.list}>
          <li>
            Review time: Up to <b>48 hours</b>
          </li>
          <li>You will receive an email once approved</li>
          <li>Payments will be available after approval</li>
        </ul>
        <p className={styles.description}>
          If additional information is required, we will contact you by email.
        </p>
      </>
    );
  };

  const renderContent = () => (
    <div
      className={classNames(styles.wrapper, {
        [styles.desktop]: isDesktop
      })}
    >
      {renderDescription()}
    </div>
  );

  const renderBtnSubmit = () => (
    <Button type="primary" onClick={onClose}>
      Return to Dashboard
    </Button>
  );

  const renderDesktopView = () => (
    <DesktopModalLayout
      title="Account under review"
      maxWidth450={true}
      onClose={undefined}
      btnSubmit={renderBtnSubmit()}
    >
      {renderContent()}
    </DesktopModalLayout>
  );

  const renderMobileView = () => (
    <MainLayout
      header={{
        title: "Account under review",
        hideMenu: true
      }}
      footer={renderBtnSubmit()}
      hideBanner={true}
    >
      {renderContent()}
    </MainLayout>
  );

  return (
    <>
      <BrowserView>{renderDesktopView()}</BrowserView>
      <MobileView>{renderMobileView()}</MobileView>
    </>
  );
}

export default AccountPendingReviewModal;
